import {GbpConfiguration, GbpConfigurationJson} from '/src/com/yext/listingslaunchstorm/js/data/gbpconfiguration';
import {MatchedListing} from '/src/com/yext/listingslaunchstorm/js/data/matchedlisting';

/**
 * @fileoverview Model representing a Launch Listings request.
 *
 * @author Kuber Sethi (ksethi@yext.com)
 */
export class LaunchListingsRequest {
  /**
   * @param {{
   *  publisherId: number,
   *  gbpConfigurations: !Array<!GbpConfiguration>,
   * }} params
   */
  constructor(params) {
    /** @type {number} */
    this.publisherId = params.publisherId;
    /** @type {!Array<!GbpConfiguration>} */
    this.gbpConfigurations = params.gbpConfigurations;
  }

  /**
   * @override
   * @return {!LaunchListingsRequestJson}
   */
  toJSON() {
    return {
      'publisherId': this.publisherId,
      'gbpConfigurations': this.gbpConfigurations.map(c => c.toJSON()),
    };
  }
}

/**
 * @dict
 * @typedef {{
 *  publisherId: number,
 *  gbpConfigurations: !Array<!GbpConfigurationJson>,
 * }}
 */
export var LaunchListingsRequestJson;
